import React from 'react';
import { Row } from '@amzn/atoz-web/Row';
import { EventLegend } from './EventLegend';
import { WEEKLY_SCHEDULE_FOOTER } from '../testids.consts';
import { IconSize } from '@amzn/atoz-web/Icons';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { FooterDimensions } from '../dimensions.consts';
export function Footer(_a) {
    var eventTypeMapping = _a.eventTypeMapping;
    return (React.createElement(FooterContainer, { dataTestId: WEEKLY_SCHEDULE_FOOTER, "aria-hidden": true },
        React.createElement(LegendContainer, null, (function () {
            var eventLegend = [];
            eventTypeMapping.forEach(function (_a) {
                var label = _a.label, icon = _a.icon;
                var styledIcon = React.cloneElement(icon, {
                    size: IconSize.Small,
                    margin: { right: 'S200', left: 'S200' }
                });
                eventLegend.push(React.createElement(EventLegend, { key: label, label: label, icon: styledIcon }));
            });
            return eventLegend;
        })())));
}
var LegendContainer = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return "\n        align-items: center;\n        justify-content: center;\n        flex-wrap: wrap;\n        max-width: ".concat(FooterDimensions.legendMaxWidth, ";\n        gap: ").concat(theme.selectors.space('S200'), "px\n    ");
});
var FooterContainer = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return "\n        justify-content: center;\n        padding:  ".concat(theme.selectors.space('S300'), "px 0px;\n        box-shadow: 0 -5px 5px -5px ").concat(theme.selectors.color('neutral40'), ";\n        z-index: 1;\n    ");
});
